import React from "react";
import styled from "styled-components";

const IconLabelWrapper = styled.div`
  && {
    display: flex;
    justify-content: center;
    padding-left: 5px;
  }
`;
const Icon = styled.div`
  && {
    color: rgba(0, 0, 0, 0.8);
  }
`;

const Label = styled.div`
  && {
    padding: 2px 0 0 7px;
  }
`;

export const LabelWithIcon = props => {
  const { icon, label } = props;
  return (
    <IconLabelWrapper>
      <Icon>{icon}</Icon>
      <Label>{label}</Label>
    </IconLabelWrapper>
  );
};



// WEBPACK FOOTER //
// ./src/components/LabelWithIcon.js